module.exports = __webpack_public_path__ + "static/Yiguo Sun.83597b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Yiguo Sun.jpg
// module id = 1246
// module chunks = 6166952557895